module.exports = __webpack_public_path__ + "a35efbbc06a992fde470d71f424ee474.svg";